import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login"; // Placeholder for OAuth login
import LandingPage from "./pages/LandingPage";
import GoogleAuthCallback from "./pages/GoogleAuthCallback"; // ✅ Create this page
import StarsPage from "./pages/StarsPage";
import ThoughtsPage from "./pages/ThoughtsPage";
import AboutPage from "./pages/AboutPage";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/accounts/google/login/callback/" element={<GoogleAuthCallback />} />  {/* ✅ Add this route */}
        <Route path="/stars" element={<StarsPage />} />
        <Route path="/thoughts" element={<ThoughtsPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
